import { render, staticRenderFns } from "./MyAppExamine.vue?vue&type=template&id=13ef2bd8&"
import script from "./MyAppExamine.vue?vue&type=script&lang=js&"
export * from "./MyAppExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports